// /src/components/MenuItemContentBody.js
import React from 'react';

const MenuItemContentBody = ({ content }) => {
    return <p style={{ color: '#333' }}>{content}</p>;
};

export default MenuItemContentBody;
